import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import Product from '../../models/Product';


export interface ProductDetailState extends ApiState {
  product?: Product
}

export default requestReducer<ProductDetailState>('PRODUCT_DETAIL')
